// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1Fvjy","title":"Header_title__l50Ie","side":"Header_side__3LMGt"};